// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const stepLabelText = {
  fontWeight: 600,
  fontSize: '12px',
  textTransform: 'uppercase',
};

const styles = (theme: any) => ({
  stepper: {
    backgroundColor: 'transparent',
    width: '100%',
    padding: 0,
  },
  stepLabel: {
    '& .MuiStepLabel-labelContainer': {
      '.MuiStepLabel-label.MuiStepLabel-alternativeLabel': {
        marginTop: '10px',
      },
      '.MuiStepLabel-label.Mui-completed, .MuiStepLabel-label.Mui-active': {
        color: theme.palette.common.white,
        ...stepLabelText,
      },
      '.MuiStepLabel-label.Mui-disabled': {
        color: '#FFFFFF80',
        ...stepLabelText,
      },
    },
  },
});

export default styles;
